import React, { useState } from 'react';
import { supabase } from '../../supabase';
import SafeIcon from '../../common/SafeIcon';
import { FiMail, FiLock, FiLayout, FiUserPlus, FiArrowRight } from 'react-icons/fi';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);
    
    if (isRegistering) {
      const { error } = await supabase.auth.signUp({ 
        email, 
        password,
      });
      if (error) {
        setError(error.message);
      } else {
        setMessage("Account created! You can now sign in.");
        setIsRegistering(false);
      }
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 border border-cream-dark animate-slide-up">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-terracotta rounded-2xl flex items-center justify-center mb-4 shadow-lg">
            <SafeIcon icon={FiLayout} className="text-white w-8 h-8" />
          </div>
          <h1 className="text-3xl font-serif font-bold text-espresso">POD Studio</h1>
          <p className="text-espresso-light/60 text-sm">
            {isRegistering ? 'Create your workspace account' : 'Sign in to manage your workspace'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-espresso-light uppercase tracking-widest mb-2">Email Address</label>
            <div className="relative">
              <SafeIcon icon={FiMail} className="absolute left-4 top-1/2 -translate-y-1/2 text-espresso-light/40" />
              <input 
                type="email" 
                required
                className="w-full pl-12 pr-4 py-3 rounded-xl border border-cream-dark focus:border-terracotta focus:outline-none bg-cream/20 text-sm"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-espresso-light uppercase tracking-widest mb-2">Password</label>
            <div className="relative">
              <SafeIcon icon={FiLock} className="absolute left-4 top-1/2 -translate-y-1/2 text-espresso-light/40" />
              <input 
                type="password" 
                required
                className="w-full pl-12 pr-4 py-3 rounded-xl border border-cream-dark focus:border-terracotta focus:outline-none bg-cream/20 text-sm"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && <p className="text-red-500 text-xs font-bold bg-red-50 p-3 rounded-lg">{error}</p>}
          {message && <p className="text-sage text-xs font-bold bg-sage/10 p-3 rounded-lg">{message}</p>}

          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-4 bg-espresso text-white rounded-xl font-bold hover:bg-espresso-light transition-all shadow-lg disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? 'Processing...' : (isRegistering ? 'Create Account' : 'Sign In')}
            {!loading && <SafeIcon icon={isRegistering ? FiUserPlus : FiArrowRight} />}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-cream-dark text-center">
          <button 
            onClick={() => {
              setIsRegistering(!isRegistering);
              setError(null);
              setMessage(null);
            }}
            className="text-xs font-bold text-terracotta hover:underline uppercase tracking-tighter"
          >
            {isRegistering 
              ? 'Already have an account? Sign In' 
              : "Don't have an account? Create one"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;